<template>
    <div v-if="componentData" class="small-wrapper grid two twoColumns">

        <Markdown class="content" :class="{ empty: !componentData.text1}" :source="componentData.text1" html breaks/>
        <Markdown class="content" :class="{ empty: !componentData.text2}" :source="componentData.text2" html breaks/>

    </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'

import Markdown from 'vue3-markdown-it';

export default defineComponent({
    components:{
        Markdown
    },
    props:{
        componentData: {
            type: Object,
            required: false
        },
    },
    setup(props) {
        const homeurl: string = import.meta.env.VITE_API_URL;

        return {
            homeurl
        };
    }
})

</script>
